import { useFrame } from '@react-three/fiber';
import { useLayoutEffect, useRef } from 'react';

export default function AutoAzimuthRotation({ speed = 0.5, children }) {
	const group = useRef();
	const ready = useRef(false);

	// turn "ready" true once children are mounted
	useLayoutEffect(() => {
		ready.current = true;
	}, []);

	useFrame((_, delta) => {
		if (group.current) {
			group.current.rotation.y += speed * delta; // constant azimuth rotation
		}
	});

	return <group ref={group}>{children}</group>;
}
